import {MD5} from "crypto-js";

export const HashObject = (obj: any): string => {
  const str = JSON.stringify(obj);
  const hash = MD5(str).toString();
  return hash;
}
